import { render, staticRenderFns } from "./DataPesertaSertifikasi.vue?vue&type=template&id=f3ff085c&scoped=true&"
import script from "./DataPesertaSertifikasi.vue?vue&type=script&lang=js&"
export * from "./DataPesertaSertifikasi.vue?vue&type=script&lang=js&"
import style0 from "./DataPesertaSertifikasi.vue?vue&type=style&index=0&id=f3ff085c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3ff085c",
  null
  
)

export default component.exports